export default{
    section:'بخش',
    uterusAdenomyosisTestsTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    uterusAdenomyosisTests:'uterus Adenomyosis Tests',
    editUterusAdenomyosisTests:'ویرایش Uterus Adenomyosis Tests',
    addUterusAdenomyosisTests:' Uterus Adenomyosis Tests جدید',
}